import axios from "axios";
import config from "../../config";

const BASE_API = config.BASE_API;
const ENDERECO_API = config.ENDERECO_API;

const listarCores = () => {
  return axios.get(BASE_API + "util/cores");
};

const listarEstadosCivis = () => {
  return axios.get(BASE_API + "util/estado-civil");
};

const listarGrausDeInstrucao = () => {
  return axios.get(BASE_API + "util/grau-instrucao");
};

const listarCapacidades = () => {
  return axios.get(BASE_API + "util/capacidades");
};

const listarTipoSanguineo = () => {
  return axios.get(BASE_API + "util/tipo-sanguineo");
};

const listarFatorRh = () => {
  return axios.get(BASE_API + "util/fator-rh");
};

const listarConselhoProfissional = () => {
  return axios.get(BASE_API + "util/conselho-profissional");
};

const listarUFsPorPais = (sigla) => {
  return axios.get(BASE_API + "util/ufs/" + sigla);
};

const listarCidadesPorUf = (uf) => {
  return axios.get(BASE_API + "util/municipios/" + uf);
};

const listarPais = () => {
  return axios.get(BASE_API + "recadastramento/paises");
};

const listarMotivoAlteracaoCadastro = () => {
  return axios.get(BASE_API + "util/motivo-alteracao-cadastro");
};

export default {
  listarCores,
  listarEstadosCivis,
  listarGrausDeInstrucao,
  listarCapacidades,
  listarTipoSanguineo,
  listarFatorRh,
  listarConselhoProfissional,
  listarPais,
  listarCidadesPorUf,
  listarUFsPorPais,
  listarMotivoAlteracaoCadastro,
};
